export default "__VITE_ASSET__u5Pnm8Qz__"